module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-clock-8841a3b3eeca3342d8fd2349d0e8d472.svg";